export default __webpack_public_path__ + "static/media/profile-updated.34a2b1c7.svg";